import { render, staticRenderFns } from "./aiSelect.vue?vue&type=template&id=44470bb2&scoped=true&"
import script from "./aiSelect.vue?vue&type=script&lang=js&"
export * from "./aiSelect.vue?vue&type=script&lang=js&"
import style0 from "./aiSelect.vue?vue&type=style&index=0&id=44470bb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44470bb2",
  null
  
)

export default component.exports